import './style.scss';
import { Outlet } from 'react-router-dom';
import { Footer } from 'views/mutual/footer';
import { Location } from 'views/mutual/location';
import { RouteAuthGuard } from 'views/auth/routeAuthGuard';
import { Header, MainMenu } from 'views/mutual/mainMenu';
import { MainLogo } from 'views/pages/logins/module/mainLogo';
import { ForceInputModal } from './forceInputModal';
import { useAgreementDocumentModal } from 'views/pages/agreementDocument/modal/hooks';
import { AgreementDocumentModal } from 'views/pages/agreementDocument/modal'

// ログイン関連のレイアウト
export const LoginLayout = () => {
  return (
    <div className={'body-before-login'}>
      <MainLogo />
      <div className="separater" />
      <Outlet />
    </div>
  );
};

// ログイン済のレイアウト
export const AuthGuardLayout = () => {
  const agreeDocumentProps = useAgreementDocumentModal();
  return (
    <RouteAuthGuard>
      {(account, accountReload) => (
        <div className="body">
          {account.ChangedPassword &&
          <>
          <AgreementDocumentModal {...agreeDocumentProps}/>
            <MainMenu account={account} />
          <Location />
          <div className="contentWrapper">
            <Outlet />
          </div>
          <Footer />                    
          </>
          }
          <ForceInputModal account={account} accountReload={accountReload}/>
        </div>
      )}
    </RouteAuthGuard>
  );
};

// ログイン関連以外のログイン前のレイアウト
export const GuestLayout = () => {
  return (
    <div className={'body'}>
      <Header />
      <Location />
      <Outlet />
    </div>
  );
};
